import React, { memo } from 'react'
import classNames from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { colorsNew, ltGtMediaQuery } from 'root/src/client/web/commonStyles'

const styles = {
	button: {
		margin: [[0, 6]],
		padding: [[2, 6]],
		borderRadius: 4,
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: 'pointer',
		border: 0,
		outline: 0,
		[ltGtMediaQuery]: {
			margin: [[5, 6]],
		},
	},
	grayout: {
		opacity: 0.4,
	},
}

const CheckboxButton = memo(({
	classes, label, color = colorsNew.dark1, checked, onClick,
}) => (
	<button
		className={classNames(
			classes.button,
			!checked && classes.grayout,
		)}
		onClick={onClick}
		style={{
			background: color,
		}}
		type="button"
	>
		<Typography
			variant={typographyVariants.miniBold}
			color={colorsNew.white}
		>
			{label}
		</Typography>
	</button>
))

export default withStyles(styles, { name: 'MuiCheckboxButton' })(CheckboxButton)
